// src/pages/pengamatan/sensus-populasi-anakan-pisang/SensusPopulasiAnakanPisangTableBody.jsx
import React from 'react';
import { TableBody, TableRow, TableCell, Checkbox, Box } from '@mui/material';
import './css/SensusPopulasiAnakanPisangTableBody.css';

const SensusPopulasiAnakanPisangTableBody = ({ 
  orders, 
  selectedItems, 
  handleSelectItem, 
  loadingOrders 
}) => {
  // Komponen untuk menampilkan status dengan styling
  const StatusBadge = ({ status }) => {
    let backgroundColor = '';
    let color = '';
    
    if (status === 'Approved') {
      backgroundColor = '#B1E1B1';
      color = '#048542';
    } else if (status === 'Processed') {
      backgroundColor = '#A4C9FE';
      color = '#007AFF';
    }
    
    return (
      <Box
        sx={{
          display: 'inline-block',
          padding: '4px 12px',
          borderRadius: '12px',
          backgroundColor: backgroundColor,
          color: color,
          fontSize: '0.75rem',
          fontWeight: '600',
          textAlign: 'center',
          minWidth: '80px'
        }}
      >
        {status}
      </Box>
    );
  };

  return (
    <TableBody>
      {orders.length > 0 ? (
        orders.map((order) => (
          <TableRow key={order.id}>
            {/* Checkbox - Fixed */}
            <TableCell 
              padding="checkbox"
              className="sensus-populasi-anakan-pisang-table-body-cell fixed checkbox"
            >
              <Checkbox
                checked={selectedItems.includes(order.id)}
                onChange={() => handleSelectItem(order.id)}
              />
            </TableCell>
            
            {/* Status Pengamatan - Fixed */}
            <TableCell className="sensus-populasi-anakan-pisang-table-body-cell fixed status-pengamatan">
              {order.status_pengamatan && order.status_pengamatan !== '-' ? (
                <StatusBadge status={order.status_pengamatan} />
              ) : (
                '-'
              )}
            </TableCell>
            
            {/* Tanggal Pengamatan - Fixed */}
            <TableCell className="sensus-populasi-anakan-pisang-table-body-cell fixed tanggal-pengamatan">
              {order.tanggal_pengamatan || '-'}
            </TableCell>
            
            {/* Kolom lainnya */}
            <TableCell className="sensus-populasi-anakan-pisang-table-body-cell fixed block">{order.block || '-'}</TableCell>
            <TableCell className="sensus-populasi-anakan-pisang-table-body-cell fixed plot">{order.plot || '-'}</TableCell>
            <TableCell className="sensus-populasi-anakan-pisang-table-body-cell">{order.luas || '-'}</TableCell>
            <TableCell className="sensus-populasi-anakan-pisang-table-body-cell">{order.rta || '0'}</TableCell>
            
            {/* Data untuk Rumpun Dengan Anakan */}
            <TableCell className="sensus-populasi-anakan-pisang-table-body-cell">{order.rda_1 || '0'}</TableCell>
            <TableCell className="sensus-populasi-anakan-pisang-table-body-cell">{order.rda_2 || '0'}</TableCell>
            <TableCell className="sensus-populasi-anakan-pisang-table-body-cell">{order.rda_3 || '0'}</TableCell>
            <TableCell className="sensus-populasi-anakan-pisang-table-body-cell">{order.rda_4 || '0'}</TableCell>
            
            {/* Data untuk Rumpun Dengan Anakan Tanpa Tagging */}
            <TableCell className="sensus-populasi-anakan-pisang-table-body-cell">{order.rdat_1 || '0'}</TableCell>
            <TableCell className="sensus-populasi-anakan-pisang-table-body-cell">{order.rdat_2 || '0'}</TableCell>
            <TableCell className="sensus-populasi-anakan-pisang-table-body-cell">{order.rdat_3 || '0'}</TableCell>
            <TableCell className="sensus-populasi-anakan-pisang-table-body-cell">{order.rdat_4 || '0'}</TableCell>
            
            <TableCell className="sensus-populasi-anakan-pisang-table-body-cell">{order.total || '0'}</TableCell>
            <TableCell className="sensus-populasi-anakan-pisang-table-body-cell">{order.keterangan || '-'}</TableCell>
          </TableRow>
        ))
      ) : (
        <TableRow>
          <TableCell 
            colSpan={17} // Sesuaikan dengan jumlah kolom
            align="center"
            className="no-data-cell"
          >
            {loadingOrders ? 'Memuat data...' : 'Tidak ada data sensus populasi anakan pisang dengan status Approved.'}
          </TableCell>
        </TableRow>
      )}
    </TableBody>
  );
};

export default SensusPopulasiAnakanPisangTableBody;